import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isString, isPlainObject } from "../../../../../utils";
import { chargeCard } from "./init";

export default function view() {
  const $this = this;
  const { $inputs } = this;

  function authModel() {
    const { auth } = isPlainObject($this.authModel) ? $this.authModel : {};
    return (auth === 'AVS' || auth === 'PIN') ? auth : null;
  }

  return (view = ViewFactory({
    NAME: 'CARD_AUTH_VIEW',
    inputs: ['pin', 'billing_address', 'billing_city', 'billing_country', 'billing_state', 'billing_zip', 'card_holder_name', 'phonenumber'],
    constants: {
      get auth() { return authModel() },
      get cardNumber() {
        const cardno = getValueAtPath($inputs, '[card_number].value');
        return isString(cardno)
          ? cardno.replace(/^\d+?(\d{4})$/, (_, $1) => `**** ${$1}`)
          : cardno;
      }
    },
    next() { authModel() && chargeCard.call($this) }
  }).call(this));
}
